<template>
  <v-layout>
    <v-flex lg10>
      <v-text-field
        v-if="prefix === '$'"
        :label="label"
        v-model="inputValue"
        :disabled="disable ? disable : !disabled"
        :prefix="prefix"
        @focusout="changeEventHandler"
        v-validate="'currency'"
        data-vv-name="currency"
        :error-messages="errors.collect('currency')"
        hide-details
      ></v-text-field>
      <v-text-field
        v-else
        :label="label"
        v-model="inputValue"
        :disabled="disable ? disable : !disabled"
        @focusout="changeEventHandler"
        v-validate="'required|number'"
        data-vv-name="number"
        :error-messages="errors.collect('number')"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex>
      <v-checkbox
        :disabled="disable"
        v-model="disabled"
        label="Amend"
        hide-details
      ></v-checkbox>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'arb-checkbox-input',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    label: {
      type: String
    },
    prefix: {
      type: String
    },
    hasCheckboxInput: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputValue: this.value,
      disabled: false
    }
  },
  watch: {
    value () {
      this.inputValue = this.value
    },
    inputValue (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    changeEventHandler () {
      this.$validator.validateAll().then(result => {
        result && this.$emit('change', this.inputValue)
      })
    }
  }
}
</script>
